import React, { Fragment, useEffect, useState } from 'react'
import {Link} from 'gatsby'
import Media from 'react-media'

export default (props) => {
    
    const openHeaderMenu = (menu) => {
        menu(true)
        document.getElementsByTagName('body')[0].className = 'headerOpen';
    }

    const handleMobileClick = (menu, toggleMenu) => {

        if(toggleMenu){
            menu(false)
            document.getElementsByTagName('body')[0].className = '';
        }else{
            menu(true)
            document.getElementsByTagName('body')[0].className = 'headerOpen';
        }
    }

    return (
        <Fragment>
            <Media query="(max-width: 767px)">
                {
                    matches =>
                        matches ? (
                            <span className="transparentBtn m" onClick={() => handleMobileClick(props.onMouseEneter, props.readHeader)}  >
                                {props.leftIcon} <span className="dropDown-heading" style={{color: props.textColor}}>{props.text}</span> {props.rightIcon}
                            </span>
                        ) : (
                            <span className="transparentBtn d" onMouseEnter={ () => openHeaderMenu(props.onMouseEneter)} >
                                {props.leftIcon} <span className="dropDown-heading" style={{color: props.textColor}}>{props.text}</span> {props.rightIcon}
                            </span>
                        )
                }
            </Media>
            
            <div style={{display: props.readHeader ? 'inline-block' : 'none'}} className="dropDown-menu">
                <ol>
                    {
                        props.menuItems.map((n, key) => {
                            return (
                                <li key={key}>
                                    {
                                        n.linkType === 'internal' ?
                                            <Link to={n.link} >
                                                {n.icon} <label> {n.title}</label>
                                                {
                                                    n.subTitle !== '' && (
                                                        <p>{n.subTitle}</p>
                                                    )
                                                }
                                            </Link>
                                        :
                                            <a href={n.link} target={n.target}>
                                                {n.icon} <label> {n.title}</label>
                                                {
                                                    n.subTitle !== '' && (
                                                        <p>{n.subTitle}</p>
                                                    )
                                                }
                                            </a>

                                    }
                                </li>
                            )
                        })
                    }
                </ol>
            </div>
        </Fragment>
    )
}